import { z } from 'zod'
import StorageManager from '../StorageManager'

// Written once, never cleared: a browser whose IndexedDB failed keeps its books
// in localStorage for good, so no book ever lives in both stores. Kept off the
// `photo-book-` prefix, which the localStorage backend reads as book slots.
const PHOTO_BOOK_STORAGE_BACKEND_STORAGE_KEY = 'photoBookStorageBackend'

const LocalStorageBackendMarkSchema = z.literal('local-storage')

export type PhotoBookLocalStorageFallbackReason =
  | 'no-indexeddb'
  | 'indexeddb-failed'
  | 'indexeddb-timed-out'

export const isBrowserMarkedForLocalStoragePhotoBooks = (): boolean =>
  LocalStorageBackendMarkSchema.safeParse(
    StorageManager.get<unknown>(PHOTO_BOOK_STORAGE_BACKEND_STORAGE_KEY)
  ).success

export const markBrowserForLocalStoragePhotoBooks = (): void => {
  StorageManager.set(
    PHOTO_BOOK_STORAGE_BACKEND_STORAGE_KEY,
    LocalStorageBackendMarkSchema.value
  )
}
